var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgImageSolid = function SvgImageSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.223 5.625c.984 0 1.75.793 1.75 1.75v8.75c0 .984-.793 1.75-1.75 1.75h-10.5c-.957 0-1.75-.766-1.75-1.75v-8.75c0-.957.793-1.75 1.75-1.75h10.5Zm-9.188 1.75a1.33 1.33 0 0 0-1.312 1.313c0 .738.547 1.312 1.312 1.312.738 0 1.313-.574 1.313-1.313a1.33 1.33 0 0 0-1.313-1.312Zm9.16 8.531c.055-.136.055-.328-.027-.437l-3.5-5.25a.427.427 0 0 0-.355-.219c-.165 0-.301.082-.383.219l-2.543 3.828-.903-1.23c-.082-.11-.191-.192-.328-.192a.427.427 0 0 0-.355.191l-1.914 2.625c-.11.137-.11.301-.055.465a.45.45 0 0 0 .41.219h9.57c.137 0 .301-.082.383-.219Z"
  })));
};

export default SvgImageSolid;